import { CSSProperties, FC, useRef } from "react";
// 常量
import { DragpreviewProps } from "./interface";

/** 预览项 */
const Dragpreview: FC<DragpreviewProps> = props => {
  const { actionRef } = props;
  const previewRef = useRef<HTMLDivElement>(null);
  /** 显示 */
  const handleShow = (style: CSSProperties) => {
    handleSetStyle({...style, display: 'block'});
  };
  /** 隐藏 */
  const handleHide = () => {
    handleSetStyle({display: 'none'});
  };
  /** 移动 */
  const handgeMove = (style: CSSProperties) => {
    handleSetStyle(style);
  };
  /** 设置样式 */
  const handleSetStyle = (style: CSSProperties) => {
    const previewDom = previewRef.current;
    if (!previewDom) return;
    for (let [key, value] of Object.entries(style)) {
      previewDom.style[key as any] = typeof value === 'number' ? `${value}px` : value;
    }
  }; 
  /** 对外方法 */
  actionRef.current = {
    show: handleShow,
    hide: handleHide,
    move: handgeMove,
  };
  return (
    <div className="drag-drop-preview" ref={previewRef}></div>
  );
};

export default Dragpreview;
